import {
  ProfitableDaysWidgetProps,
  WidgetConfig,
  WidgetDataDependencies,
  WidgetType,
} from '../../types/widget-manager.types';
import { BaseWidgetStrategy } from './base-widget-strategy';

/**
 * Forex widget strategy
 * Returns: ProfitableDays, MaxLoss, DailyLimit, Payout widgets
 */
export class ForexWidgetStrategy extends BaseWidgetStrategy {
  getWidgetConfigs(data: WidgetDataDependencies): WidgetConfig[] {
    if (!this.validateData(data)) {
      return [];
    }

    const configs: WidgetConfig[] = [];

    // ProfitableDays widget (Forex-specific)
    configs.push({
      type: WidgetType.ProfitableDays,
      props: {
        account: data.account,
        accountBalance: data.accountBalance,
        program: data.program,
        profitableDays: data.profitableDays,
      } as ProfitableDaysWidgetProps,
      enabled: true,
      order: 1,
    });

    // MaxLoss widget
    configs.push({
      type: WidgetType.MaxLoss,
      props: {
        account: data.account,
        accountBalance: data.accountBalance,
        program: data.program,
      },
      enabled: true,
      order: 2,
    });

    // DailyLimit widget
    configs.push({
      type: WidgetType.DailyLimit,
      props: {
        account: data.account,
        accountBalance: data.accountBalance,
        program: data.program,
      },
      enabled: true,
      order: 3,
    });

    // Payout widget
    configs.push({
      type: WidgetType.Payout,
      props: {
        account: data.account,
        eligibilityData: data.eligibilityData,
      },
      enabled: true,
      order: 4,
    });

    // Sort by order and filter valid configs
    return this.filterValidConfigs(configs).sort((a, b) => {
      const orderA = a.order ?? 999;
      const orderB = b.order ?? 999;
      return orderA - orderB;
    });
  }
}
